export class Bid {
  actor: string;
  actorID: string;
  offer: number;
  date: string;
  event: string;
}
